import { Button } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import React from "react";
import * as XLSX from "xlsx";

interface DemoExportExcelProps {
  onLySerial?: boolean;
  noSerialStatus?: boolean;
}

export const DemoExportExcel: React.FC<DemoExportExcelProps> = ({
  onLySerial,
  noSerialStatus, // Cái này chỉ xài cho xuất kho, sửa nhập kho đừng quan tâm cái này !
}) => {
  const handleGenerate = () => {
    let rows: any[] = [];
    let headers: any[] = [];
    // Tiêu đề cột
    if (onLySerial) {
      headers = !noSerialStatus
        ? [
            "Serial",
            "SerialStatus",
            "SerialNote",
            "Ghi chú: Vui lòng nhập đầy đủ thông tin vào đúng hàng và đúng cột. Đối với các mã, vui lòng để định dạng là Text.",
          ]
        : [
            "Serial",
            "Ghi chú: Vui lòng nhập đầy đủ thông tin vào đúng hàng và đúng cột. Đối với các mã, vui lòng để định dạng là Text.",
          ];

      rows = [
        headers,
        !noSerialStatus
          ? ["MSLOGM19674631", "Bán bình thường", "Ghi chú tình trạng"]
          : ["MSLOGM19674631"],
      ];
    } else {
      // headers = [
      //   "Mã hàng",
      //   "Tên hàng",
      //   "Số Serial",
      //   "Số lượng",
      //   "Giá nhập",
      //   "Đơn vị tính",
      //   "Thời gian BH serial con(tháng)",
      //   "Thời gian BH(tháng)",
      //   "Serial hộp(Serial cha)",
      //   "",
      //   "Ghi chú: Vui lòng nhập đầy đủ thông tin vào đúng hàng và đúng cột. Đối với các mã, vui lòng để định dạng là Text.",
      // ];
      // rows = [
      //   headers,
      //   [
      //     "MSLOGM19674631",
      //     "Chuột không dây Logitech M196, màu trắng (910-007463)",
      //     "2437SC3226S8",
      //     1,
      //     "CHIEC",
      //     0,
      //     12,
      //     12,
      //     "2437SC3226S9",
      //   ],
      // ];
      headers = !noSerialStatus
        ? [
            "PHIẾU NHẬP",
            "MÃ SP",
            "TÊN SP",
            "barcode cha",
            "Tình trạng",
            "Ghi chú tình trạng",
            "barcode con",
            "TÊN SP CON",
            "Thời gian bảo hành",
            "Tình trạng serial con",
            "",
            "Ghi chú: Vui lòng nhập đầy đủ thông tin vào đúng hàng và đúng cột. Đối với các mã, vui lòng để định dạng là Text.",
          ]
        : [
            "PHIẾU NHẬP",
            "MÃ SP",
            "TÊN SP",
            "barcode cha",
            "barcode con",
            "TÊN SP CON",
            "Thời gian bảo hành",
            "",
            "Ghi chú: Vui lòng nhập đầy đủ thông tin vào đúng hàng và đúng cột. Đối với các mã, vui lòng để định dạng là Text.",
          ];
      rows = [
        headers,
        !noSerialStatus
          ? [
              "01051",
              "AMST0002",
              "Ấm Siêu Tốc E-Dra EK2001 (Hàng KM)",
              "UEVWEAVWEEW43534242",
              "Bán bình thường",
              "Ghi chú tình trạng",
              "con123321212423234",
              "",
              12,
              "",
            ]
          : [
              "01051",
              "AMST0002",
              "Ấm Siêu Tốc E-Dra EK2001 (Hàng KM)",
              "UEVWEAVWEEW43534242",
              "con123321212423234",
              "",
              12,
            ],
      ];
    }

    const worksheet = XLSX.utils.aoa_to_sheet(rows);
    const range = XLSX.utils.decode_range(worksheet["!ref"] ?? "");
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
      if (!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = {
        fill: {
          fgColor: { rgb: "FFFF00" },
        },
        font: {
          bold: true,
          color: { rgb: "000000" },
        },
        border: {
          top: { style: "thin", color: { rgb: "000000" } },
          bottom: { style: "thin", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "000000" } },
          right: { style: "thin", color: { rgb: "000000" } },
        },
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
      };
    }

    worksheet["!cols"] = headers.map((header) => ({
      wch: header.length + 3,
    }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách");
    XLSX.writeFile(workbook, "Mau Import Excel Serial.xlsx");
  };

  return (
    <div>
      <Button
        leftSection={<IconDownload size={14} />}
        color="teal"
        onClick={handleGenerate}
      >
        Tải file mẫu
      </Button>
    </div>
  );
};
